<template>
  <div style="margin-top:10px;padding:10px;" class="card">
    <b-table
      style="font-size:12px;"
      :data="questions"
      :paginated="nb_questions()"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="false"
      :striped="true"
      :hoverable="true"
      checkable
      :checked-rows.sync="checkedRows"
    >
      <template>
        <b-table-column
          v-slot="props"
          custom-key="question.proposer_public"
          field
          :label="$t('question.proposer_public')"
          centered
          width="100"
        >
          <div class="field" @click="toggleTypeQuestion(props.row), $event">
            <b-switch
              :value="checkEtat(props.row.state)"
              type="is-primary"
            ></b-switch>
          </div>
        </b-table-column>
        <b-table-column
          v-slot="props"
          custom-key="question.mettre_en_avant"
          field
          :label="$t('question.mettre_en_avant')"
          centered
          width="100"
        >
          <div class="field" @click="togglePinnedQuestion(props.row), $event">
            <b-switch
              :value="checkPinned(props.row.pinned)"
              type="is-primary"
            ></b-switch>
          </div>
          <div @click="togglePinnedQuestion(props.row), $event"></div>
        </b-table-column>
        <b-table-column
          v-slot="props"
          custom-key="question.hasbeenpublished"
          field
          :label="$t('question.hasbeenpublished')"
          centered
          width="100"
        >
          <b-icon
            pack="fas"
            icon="check"
            size="is-small"
            v-if="props.row.hasbeenpublished"
          ></b-icon>
        </b-table-column>
        <b-table-column
          v-slot="props"
          custom-key="question.question"
          field
          :label="$t('question.question')"
        >
          <span v-if="props.row.media">
            <span v-if="getExtension(props.row.media, 'image')">
              <img :src="url_media + props.row.media" class="img_jointe" />
            </span>
            <span v-if="getExtension(props.row.media, 'video')">
              <video
                controls
                :src="url_media + props.row.media"
                class="img_jointe"
              ></video>
            </span>
          </span>
          <span v-html="affiche_question(props.row.id+' / '+props.row.question)"></span>
        </b-table-column>
        <b-table-column
          v-slot="props"
          custom-key="common.modifier"
          field
          :label="$t('common.modifier')"
          centered
          width="40"
        >
          <div @click="editQuestion(props.row), $event">
            <b-icon pack="fas" icon="edit" size="is-small"></b-icon>
          </div>
        </b-table-column>
        <b-table-column
          v-slot="props"
          custom-key="common.repondre"
          field
          :label="$t('common.repondre')"
          centered
          width="40"
        >
          <div
            v-if="!props.row.response"
            @click="replyQuestion(props.row), $event"
          >
            <b-icon pack="fas" icon="reply" size="is-small"></b-icon>
          </div>
          <div
            v-if="props.row.response"
            style="display:flex;flex-direction:row;justify-content:center"
          >
            <div @click="replyQuestion(props.row), $event">
              <b-icon pack="fas" icon="pen" size="is-small"></b-icon>
            </div>
            <div @click="destroyResponse(props.row), $event">
              <b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon>
            </div>
          </div>
        </b-table-column>
        <b-table-column
          v-slot="props"
          custom-key="common.supprimer"
          field
          :label="$t('common.supprimer')"
          centered
          width="40"
        >
          <div @click="deleteQuestion(props.row), $event">
            <b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon>
          </div>
        </b-table-column>
      </template>
    </b-table>
    <PopupRepondreQuestion
      :question_id="currentQuestion"
      :getQuestionsFirstTime="getQuestionsFirstTime"
    />
  </div>
</template>

<script>
import axios from "axios";
import PopupRepondreQuestion from "@/components/base/PopupRepondreQuestion";
export default {
  name: "Questions",
  components: {
    PopupRepondreQuestion
  },
  props: {
    questions: {
      required: true
    },
    meeting_id: {
      required: true
    },
    url_moderateur: {
      required: true
    },
    getQuestionsFirstTime: {
      required: true
    }
  },
  data() {
    return {
      perPage: 20,
      currentPage: 1,
      checked_questions: [],
      update_question_values: {
        pinned: "0",
        hasbeenpublished: 0
      },
      checkedRows: [],
      url_media: process.env.URL_MEDIA,
      currentQuestion: -1
    };
  },
  watch: {
    checkedRows(value) {
      this.$emit("checked", value);
    }
  },
  methods: {
    scrollToTopParent() {
      let message = {
        task: "scrollToTop"
      };
      window.top.postMessage(message, "*");
    },
    NbrChecked() {
      if (this.checked_questions.length > 0) {
        return "(" + this.checked_questions.length + ")";
      }
    },
    checkEtat(etat) {
      if (etat == "pending") return false;
      else return true;
    },
    checkPinned(etat) {
      if (etat == "0") {
        return false;
      } else {
        return true;
      }
    },
    nb_questions() {
      if (this.questions.length > this.perPage) return true;
      else return false;
    },
    getExtension(chemin, type_test) {
      var extensionsIMG = new Array("png", "gif", "jpg", "jpeg");
      var extensionsVIDEO = new Array("mp4");
      var regex = /[^.]*$/i;
      var resultats = chemin.match(regex);
      if (type_test == "video" && extensionsVIDEO.indexOf(resultats[0]) != -1) {
        return 1;
      }
      if (type_test == "image" && extensionsIMG.indexOf(resultats[0]) != -1) {
        return 1;
      }

      return 0;
    },
    affiche_question(laQuestion) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      if (laQuestion) {
        laQuestion = laQuestion.replace(urlRegex, function(url, b, c) {
          var url2 = c == "www." ? "http://" + url : url;
          return '<a href="' + url2 + '" target="_blank">' + url + "</a>";
        });
      }
      return laQuestion;
    },
    toggleTypeQuestion(question, event) {
      var new_state;
      if (question.state == "pending") new_state = "published";
      else new_state = "pending";
      var update_question_values = {
        state: new_state
      };
      axios.defaults.headers.common["urlmoderateur"] = this.url_moderateur;
      axios
        .put(
          process.env.URL_SSO_API +
            "textit/public/meeting/" +
            this.meeting_id +
            "/question/" +
            question.id,
          update_question_values
        )
        .then(response => {})
        .catch(error => {
          alert("erreur dans le changement etat");
        });
    },
    editQuestion(question, event) {
      this.scrollToTopParent();
      this.$store.dispatch("HydrateEditQuestion", question);
      this.$store.dispatch("popupToggleEditQuestion");
    },
    replyQuestion(question, event) {
      this.scrollToTopParent();
      this.currentQuestion = question.id;
      if (question.response) {
        this.$store.dispatch("HydrateEditQuestion", question);
      } else {
        this.$store.dispatch("HydrateEditQuestion", {
          response: {
            response: "",
            media: null,
            file: null
          }
        });
      }
      this.$store.dispatch("popupToggleReplyQuestion");
    },
    destroyResponse(question) {
      axios.defaults.headers.common["urlmoderateur"] = this.url_moderateur;
      axios
        .delete(
          process.env.URL_SSO_API +
            "textit/public/questions/" +
            question.id +
            "/responses/" +
            question.response.id
        )
        .then(response => {
          console.log(response);
          this.getQuestionsFirstTime();
        })
        .catch(error => {
          alert("erreur dans le changement etat");
        });
    },
    deleteQuestion(question, event) {
      axios.defaults.headers.common["urlmoderateur"] = this.url_moderateur;
      axios
        .delete(
          process.env.URL_SSO_API +
            "textit/public/meeting/" +
            this.meeting_id +
            "/question/" +
            question.id
        )
        .then(response => {})
        .catch(error => {
          alert("erreur dans la suppression");
        });
    },
    checked(id_question, event) {
      if (event.target.checked) this.checked_questions.push(id_question);
      else {
        this.checked_questions = this.checked_questions.filter(
          question => question != id_question
        );
      }
    },
    togglePinnedQuestion(question, event) {
      if (question.pinned == "0") {
        this.update_question_values = {
          pinned: 1,
          hasbeenpublished: 1
        };
      } else if (question.pinned == "1") {
        this.update_question_values = {
          pinned: 0,
          hasbeenpublished: 1
        };
      } else {
        this.update_question_values = {
          pinned: 0,
          hasbeenpublished: 0
        };
      }

      axios.defaults.headers.common["urlmoderateur"] = this.url_moderateur;
      axios
        .put(
          process.env.URL_SSO_API +
            "textit/public/meeting/" +
            this.meeting_id +
            "/question/" +
            question.id,
          this.update_question_values
        )
        .then(response => {})
        .catch(error => {
          alert("erreur dans le changement etat");
        });
    }
  }
};
</script>
<style scoped>
.img_jointe {
  float: left;
  margin: 5px 10px 5px 0;
  max-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/animerPage/components/Questions.vue